export const bisectArray = (arr = [], atIndex = Math.ceil(arr.length / 2)) => {
  const group1 = arr.slice(0, atIndex);
  const group2 = arr.slice(atIndex);
  return [group1, group2];
};
